import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import ErrorPage from './pages/ErrorPage';
import IndexPage from './pages/Index';
import ResumenValidadoPage from './pages/ResumenValidadoPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



function App() {
  const basename = document.querySelector('base')?.getAttribute('href') ?? '/'    
  return (
   <>
    <Header/>
            <Router basename={basename}>
                <Routes>
                    <Route path=""  element={<IndexPage/>}/>
                    <Route path="resumenValidado" element={<ResumenValidadoPage/>}/>
                    <Route path="*" element={<ErrorPage/>}/>
                </Routes>
            </Router>
            <Footer/>
   </>
  );
}

export default App;
